package org.moxultimate.topwithmox.di

import org.koin.dsl.module
import org.moxultimate.topwithmox.libraries.sample.GreetingRepository
import org.moxultimate.topwithmox.libraries.sample.GreetingRepositoryImpl
import org.moxultimate.topwithmox.libraries.sample.KoinSampleViewModel

/**
 * Koin module for the [KoinSample] demo.
 *
 * Binding conventions used here:
 * - `single { }` — one shared instance for the app lifetime (singleton).
 * - `factory { }` — new instance on every `get()` / `inject()` call.
 * - `viewModelOf(::MyVM)` — ViewModel with automatic constructor injection
 *   (requires koin-compose; here we use `factory` since we manage lifecycle
 *    manually via [org.moxultimate.topwithmox.core.base.rememberViewModel]).
 */
val sampleModule = module {

    // Repository — singleton so state is shared across the app
    single<GreetingRepository> { GreetingRepositoryImpl() }

    // ViewModel — factory so each composable gets a fresh instance
    factory { KoinSampleViewModel(get()) }
}
